// MyStuff.js

import React, { useState, useEffect, useContext, useRef } from 'react';
import {
      CButton, CCard, CCardHeader, CCardBody, CCol, CContainer, CForm,
      CFormInput, CInputGroup, CInputGroupText, CRow, CFormSelect,
      CModal, CModalHeader, CModalBody, CModalFooter
} from '@coreui/react';
import { toast } from 'react-toastify';
import { FirebaseContext } from '../../firebase'; // Adjust the path
import { getDatabase, ref, get, query, orderByChild, equalTo } from 'firebase/database';
import { AuthUserContext, withAuthorization, withEmailVerification } from '../../session';
import emptyAuctions from '../../../assets/no-auction-listing.png';
import ArtworkCard from '../../../components/ArtworkCard';
import { ActiveLinkContext } from '../../../components/ActiveLinkContext';
import '../../../scss/main.scss';
import NewArtwork from '../../../components/NewArtwork';
import 'react-toastify/dist/ReactToastify.css';
import Spinner from '../../../components/Spinner';
import ArtworkService from '../../../services/Artwork';
import AuctionService from '../../../services/Auctions';
import UserService from '../../../services/Users';
import BlockchainExplorer from '../../../components/BlockchainExplorer';
import { useNavigate, useLocation, Routes, Route } from 'react-router-dom';
import config from '../../../utils/EnvironmentSwitcher';
import MarketplaceService from '../../../services/MarketplaceService';
import { LISTING_STATUS } from '../../../services/Constants';
import ListNFTModal from '../../../components/ListNFTModal';
import ArtworkDetailModal from '../../../components/ArtworkDetailModal';
import Logger from '../../../utils/Logger';

// IPFS gateway URL for MiEROS (no client needed, just URL construction)
const IPFS_GATEWAY = 'https://ipfs.mieros.cloud/ipfs';

const ITEMS_PER_PAGE = 3;
const SPINNER_TIMEOUT = 30000; // 3 seconds

const MyStuff = ({ authUser }) => {
      //console.log('MyStuff rendered', authUser.authUser.email);
      const { firebase, db } = useContext(FirebaseContext);
      const { setActiveLink } = useContext(ActiveLinkContext);
      const [searchTerm, setSearchTerm] = useState('');
      const [category, setCategory] = useState('All');
      const [items, setItems] = useState([]);
      const [showInput, setShowInput] = useState(false);
      const [mieTokenExists, setMieTokenExists] = useState(false);
      const [securePassword, setSecurePassword] = useState('');
      const [filteredItems, setFilteredItems] = useState([]);
      const [isConnected, setIsConnected] = useState(false);
      const [isButtonDisabled, setIsButtonDisabled] = useState(false);
      const [newNotificationCount, setNewNotificationCount] = useState(0);
      const [isLoadingYourArtwork, setIsLoadingYourArtwork] = useState(true);
      const [isLoadingOpenAuctions, setIsLoadingOpenAuctions] = useState(true);
      const [yourArtwork, setYourArtwork] = useState([]);
      const [openAuctions, setOpenAuctions] = useState([]);
      const [selectedArtwork, setSelectedArtwork] = useState({});
      const [selectedNft, setSelectedNft] = useState({});
      const [nftID, setNftID] = useState(null);
      const [nftIndex, setNftIndex] = useState(null);
      const [isBidding, setIsBidding] = useState(false);
      const [isViewingArtwork, setIsViewingArtwork] = useState(false);
      const [currentPage, setCurrentPage] = useState(0);
      const [hasError, setHasError] = useState(false);
      const navigate = useNavigate();
      const location = useLocation();
      const artworkService = new ArtworkService();
      const [modalVisible, setModalVisible] = useState(false);
      const auctionService = new AuctionService();
      const userService = new UserService();
      const [password, setPassword] = useState('');
      const [mieWalletExists, setMieWalletExists] = useState(null);
      const [userListings, setUserListings] = useState([]);
      const [notifications, setNotifications] = useState([]);
      const marketplaceService = new MarketplaceService();
      const [showNewArtworkModal, setShowNewArtworkModal] = useState(false);
      const [showListNFTModal, setShowListNFTModal] = useState(false);
      const [selectedNFTForListing, setSelectedNFTForListing] = useState(null);
      const [listedItemsCount, setListedItemsCount] = useState(0);
      const [showDetailModal, setShowDetailModal] = useState(false);
      const [selectedDetailArtwork, setSelectedDetailArtwork] = useState(null);
      const [isVerifiedCreator, setIsVerifiedCreator] = useState(false);
      // Track listing IDs we just cancelled so refetch doesn't overwrite with stale API data
      const recentlyCancelledListingIds = useRef(new Set());

      const closeModal = () => {
            setModalVisible(false); // Hide the modal
            setIsViewingArtwork(false);
            setSelectedArtwork({});
            setNftID(null);
            setNftIndex(null);
      };

      const handlePasswordChange = (event) => {
            setSecurePassword(event.target.value);
      };


      const resetForm = () => {
            setSecurePassword('');
      };

      useEffect(() => {
            let filtered = items;
            if (category !== 'All') {
                  filtered = filtered.filter(item => item.category === category);
            }
            if (searchTerm) {
                  filtered = filtered.filter(item => item.title.toLowerCase().includes(searchTerm.toLowerCase()));
            }
            setFilteredItems(filtered);
      }, [searchTerm, category, items]);

      useEffect(() => {
            if (authUser) {
                  getYourArtwork();
            }
      }, [authUser, db]);


      const handleSearchChange = (event) => {
            Logger.debug("Search term changed:", event.target.value);
            setSearchTerm(event.target.value);
      };

      const handleCategoryChange = (event) => {
            Logger.debug("Category changed:", event.target.value);
            setCategory(event.target.value);
      };

      const generateSecurePassword = (length = 12) => {
            const array = new Uint8Array(length);
            window.crypto.getRandomValues(array);
            return Array.from(array, byte => ('0' + byte.toString(16)).slice(-2)).join('').slice(0, length);
      };

      const handleConnectToMieros = async (event) => {
            event.preventDefault();
            const sanitizedUser = { username: authUser.authUser.uid, password: securePassword };

            try {
                  const response = await userService.login(sanitizedUser);
                  Logger.debug("1");
                  if (response.accessToken) {
                        const currentUserSession = JSON.parse(localStorage.getItem('userSession')) || {};
                        Logger.debug("2");
                        const updatedUserSession = {
                              ...currentUserSession,
                              mieToken: response.accessToken,
                        };
                        Logger.debug("3");
                        localStorage.setItem('userSession', JSON.stringify(updatedUserSession));

                        toast.success('Successfully connected to Mieros!');
                        setIsConnected(true);
                        setIsLoadingYourArtwork(false);
                        getYourArtwork();
                  } else {
                        toast.error('Failed to connect to Mieros. Please try again.');
                  }
            } catch (error) {
                  console.error('Error during login:', error);
                  toast.error('An error occurred while connecting to Mieros.');
            }
      };

      const getYourArtwork = async () => {
            setIsLoadingYourArtwork(true);
            try {
                  const artworkData = await artworkService.getArtworkForCurrentUser();
                  Logger.debug('Raw artwork data:', artworkData);

                  // API returns { success, message, data: nfts }; accept array at .data or top-level (defensive)
                  const raw = artworkData?.data ?? artworkData;
                  const artwork = Array.isArray(raw) ? raw : [];

                  // Normalize the artwork data (listingId can be null/empty for CREATED/unlisted NFTs)
                  const cancelledSet = recentlyCancelledListingIds.current;
                  const normalizedArtwork = artwork.map(art => {
                        // Helper function to construct IPFS URL using mieros gateway
                        const getIpfsUrl = (hash) => {
                              if (!hash) return null;
                              return `https://ipfs.mieros.cloud/ipfs/${hash}`;
                        };

                        const rawListingId = art.listingId || art.listing?.listingID || null;
                        // If we just cancelled this listing, keep it as unlisted even if API returned stale data
                        const isRecentlyCancelled = rawListingId && cancelledSet.has(rawListingId);
                        if (isRecentlyCancelled) {
                              cancelledSet.delete(rawListingId);
                        }
                        const listingId = isRecentlyCancelled ? null : rawListingId;
                        const status = isRecentlyCancelled ? 'CREATED' : art.status;

                        return {
                              // Preserve original data first
                              ...art,
                              // Basic NFT info
                              nftId: art.nftId,
                              docType: art.docType,
                              status,

                              // Item details
                              title: art.itemDetail,
                              description: art.itemDescription,
                              type: art.itemType,
                              category: art.itemCategory,
                              subject: art.itemSubject,
                              media: art.itemMedia,

                              // Asset info
                              imageUrl: getIpfsUrl(art.image),
                              assetUrl: getIpfsUrl(art.asset),
                              // ArtworkCard expects itemAssetUrl / itemAssetName / type for owner downloads
                              itemAssetUrl: getIpfsUrl(art.asset),
                              itemAssetName: art.assetName || art.itemAssetName || 'download',
                              itemAssetType: art.assetType || art.itemAssetType || '',
                              assetType: art.assetType || art.itemAssetType || '',
                              assetName: art.assetName || art.itemAssetName || '',
                              itemImage: art.imageUrl || getIpfsUrl(art.image),

                              // Pricing and ownership
                              price: art.price,
                              royalty: art.royalty,
                              owner: art.owner,
                              creator: art.creator,

                              // Listing info (null when unlisted / recently cancelled so card shows correct button)
                              listingId
                        };
                  });

                  Logger.debug('Normalized artwork data:', normalizedArtwork);
                  setYourArtwork(normalizedArtwork);
            } catch (error) {
                  console.error('Error fetching artwork:', error);
                  toast.error('Failed to fetch your artwork');
                  setYourArtwork([]);
            } finally {
                  setIsLoadingYourArtwork(false);
            }
      };

      // Add a separate handler function for better debugging
      const handleCreatorNavigation = () => {
            console.log('Creator button clicked');
            const navigationState = { activeLink: 'creator' };
            console.log('Navigation state being passed:', navigationState);
            try {
                  // Update the context first
                  setActiveLink('creator');
                  // Then navigate
                  navigate('/dashboard/creator/home', { state: navigationState });
            } catch (error) {
                  console.error('Navigation error:', error);
            }
      };

      const getAllOpenAuctions = () => {
            setIsLoadingOpenAuctions(true);
            Logger.debug("Fetching all open auctions");
            auctionService.getOpenAuctions()
                  .then(response => {
                        setOpenAuctions(response);
                        setIsLoadingOpenAuctions(false);
                  })
                  .catch(err => {
                        console.error("Error fetching open auctions:", err);
                        toast.dismiss();
                        toast.error("Failed to load open auctions");
                        setOpenAuctions([]);
                        setIsLoadingOpenAuctions(false);
                  });
      };

      const addArtworkToState = async (newArtwork) => {
            Logger.debug('Adding new artwork to state:', newArtwork);
            try {
                  // Remove the state update here since we'll fetch fresh data
                  // Instead, just show the success message and refresh
                  toast.success(`Successfully created ${newArtwork.nfts?.length || 1} NFTs!`, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                  });

                  // Close the modal
                  setShowNewArtworkModal(false);

                  // Fetch fresh data instead of updating state directly
                  await getYourArtwork();

            } catch (error) {
                  console.error('Error adding artwork:', error);
                  toast.error('Failed to add artwork to your collection');
            }
      };

      const updateOnSocketMessage = () => {
            setNewNotificationCount(0);
      };

      const reloadAuctions = () => {
            Logger.debug("Reloading auctions");
            if (!isLoadingOpenAuctions) {
                  getAllOpenAuctions();
            }
            if (!isLoadingYourArtwork) {
                  getYourArtwork();
            }
            setNewNotificationCount(0);
      };

      const handleNextPage = () => {
            if ((currentPage + 1) * ITEMS_PER_PAGE < filteredItems.length) {
                  Logger.debug("Navigating to next page");
                  setCurrentPage(currentPage + 1);
            }
      };

      const handlePrevPage = () => {
            if (currentPage > 0) {
                  Logger.debug("Navigating to previous page");
                  setCurrentPage(currentPage - 1);
            }
      };



      const handleListNFT = async (nftId, price) => {
            try {
                  setIsButtonDisabled(true);
                  const listing = await marketplaceService.listNFTForSale(nftId, price);
                  toast.success('NFT listed successfully');
                  getYourArtwork(); // Refresh artwork list
            } catch (error) {
                  toast.error(error.message);
            } finally {
                  setIsButtonDisabled(false);
            }
      };

      const handleCancelListing = async (listingId) => {
            try {
                  setIsButtonDisabled(true);
                  recentlyCancelledListingIds.current.add(listingId);
                  await marketplaceService.cancelListing(listingId);
                  // Optimistically update UI immediately so cancelled listings disappear
                  setYourArtwork(prev => prev.map(art => {
                        if (art.listingId === listingId) {
                              return {
                                    ...art,
                                    listing: null,
                                    listingId: null,
                                    status: 'CREATED'
                              };
                        }
                        return art;
                  }));
                  setListedItemsCount(count => Math.max(0, count - 1));
                  toast.success('Listing cancelled successfully');
                  // Refresh artwork list in background; recentlyCancelledListingIds keeps stale API data from re-showing the button
                  setTimeout(() => {
                        getYourArtwork();
                  }, 1200);
            } catch (error) {
                  recentlyCancelledListingIds.current.delete(listingId);
                  toast.error(error.message);
            } finally {
                  setIsButtonDisabled(false);
            }
      };

      const handleUpdatePrice = async (listingId, newPrice) => {
            try {
                  setIsButtonDisabled(true);
                  await marketplaceService.updateListingPrice(listingId, newPrice);
                  toast.success('Price updated successfully');
                  getYourArtwork(); // Refresh artwork list
            } catch (error) {
                  toast.error(error.message);
            } finally {
                  setIsButtonDisabled(false);
            }
      };

      const fetchNotifications = async () => {
            try {
                  const { notifications } = await marketplaceService.getUserNotifications();
                  if (notifications && notifications.length > 0) {
                        setNotifications(notifications);
                  }
            } catch (error) {
                  console.warn('Failed to fetch notifications:', error);
                  // Don't show error toast for now since endpoint isn't ready
            }
      };

      useEffect(() => {
            fetchNotifications();
      }, []);

      const handleListingSuccess = async (response) => {
            try {
                  Logger.debug('Listing success response:', response);
                  await getYourArtwork(); // Refresh the artwork list
                  toast.success('NFT listed successfully');
                  setShowListNFTModal(false);
                  setSelectedNFTForListing(null);
            } catch (error) {
                  Logger.error('Error handling listing success:', error);
                  toast.error('Error updating artwork list');
            }
      };

      const handleViewDetails = (art) => {
            Logger.info('Viewing details for artwork:', art.nftId);
            setSelectedDetailArtwork(art);
            setShowDetailModal(true);
            // Update the navigation path to include /dashboard
            navigate(`/dashboard/mystuff/listing/${art.listingId || art.nftId}`, {
                  replace: true,
                  state: { art }
            });
      };

      // Add useEffect to monitor state changes
      useEffect(() => {
            Logger.debug('Modal visibility changed:', showDetailModal);
            Logger.debug('Selected artwork:', selectedDetailArtwork);
      }, [showDetailModal, selectedDetailArtwork]);

      const handleModalClose = () => {
            setShowDetailModal(false);
            setSelectedDetailArtwork(null);
            // Update active link and navigate
            setActiveLink('digiart');
            navigate('/dashboard', { replace: true });
      };

      const renderYourArtwork = () => {
            if (isLoadingYourArtwork) {
                  return <Spinner />;
            }

            if (!yourArtwork.length) {
                  return (
                        <div className="col-md-6">
                              <span className="alert alert-primary">No information found!</span>
                        </div>
                  );
            }

            return (
                  <div className="row g-4">
                        {yourArtwork
                              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                              .map((art, i) => (
                                    <div key={i} className="col-md-4">
                                          <ArtworkCard
                                                {...art} // Spread all properties
                                                itemImage={art.imageUrl || art.itemImage} // Use either IPFS or direct URL
                                                itemAssetUrl={art.itemAssetUrl || art.assetUrl}
                                                itemAssetName={art.itemAssetName || art.assetName}
                                                itemAssetType={art.itemAssetType || art.assetType}
                                                nftId={art.nftId}
                                                userId={art.owner || art.creator}
                                                currentUserId={authUser?.authUser?.uid || authUser?.uid}
                                                authUser={authUser}
                                                handleClick={() => {
                                                      setSelectedArtwork(art);
                                                      setIsBidding(false);
                                                      setIsViewingArtwork(true);
                                                }}
                                                onListForSale={() => {
                                                      Logger.debug('Art object:', art);
                                                      if (art && art.nftId) {
                                                            const nftData = {
                                                                  // Required fields from ListNFTModal
                                                                  nftId: art.nftId,
                                                                  itemType: art.itemType || art.type,
                                                                  itemCategory: art.itemCategory || art.category,
                                                                  itemDetail: art.itemDetail || art.title,
                                                                  itemDescription: art.itemDescription || art.description,
                                                                  itemSubject: art.itemSubject || art.subject,
                                                                  itemMedia: art.itemMedia || art.media,
                                                                  status: art.status || 'CREATED',
                                                                  createdAt: art.createdAt || new Date().toISOString(),
                                                                  
                                                                  // Image handling
                                                                  imageUrl: art.imageUrl || art.itemImage, // Use normalized image URL
                                                                  image: art.image,
                                                                  imageType: art.imageType,
                                                                  
                                                                  // Pricing
                                                                  price: art.price || art.itemBasePrice || 0,
                                                                  priceIsFixed: true,
                                                                  
                                                                  // Additional metadata
                                                                  royalty: art.royalty || 0,
                                                                  owner: art.owner || authUser?.uid,
                                                                  
                                                                  // Preserve original data
                                                                  ...art
                                                            };

                                                            // Debug log the prepared data
                                                            Logger.debug('Prepared NFT data for listing:', nftData);

                                                            setSelectedNFTForListing(nftData);
                                                            setShowListNFTModal(true);
                                                      } else {
                                                            Logger.error('Invalid NFT data:', art);
                                                            toast.error('Invalid NFT data');
                                                      }
                                                }}
                                                onView={() => handleViewDetails(art)}
                                                onCancelListing={() => handleCancelListing(art.listingId)}
                                                showListForSale={true}
                                                isMarketplace={false}
                                                status={art.status}
                                                listingId={art.listingId}
                                          />
                                    </div>
                              ))}
                  </div>
            );
      };


      const handlePurchase = async (item) => {
            if (!authUser || !authUser.authUser) {
                  toast.error('You must be logged in to make a purchase.');
                  return;
            }

            try {
                  const response = await fetch(`${config.apiUrl}/purchase`, {
                        method: 'POST',
                        headers: {
                              'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                              itemId: item.id,
                              price: item.price,
                              royalty: item.royalty,
                              userId: authUser.authUser.uid,
                        }),
                  });

                  if (response.ok) {
                        toast.success(`Successfully purchased ${item.title}`);
                  } else {
                        throw new Error('Failed to purchase item.');
                  }
            } catch (error) {
                  console.error('Error purchasing item:', error);
                  toast.error('Error purchasing item. Please try again.');
            }
      };

      const renderHeader = () => (
            <div className="header-section mb-4">
                  <CCard className="border-0 shadow-sm">
                        <CCardBody>
                              <CRow className="align-items-center">
                                    <CCol md={6}>
                                          <h2 className="mb-0">My Collection</h2>
                                          <p className="mb-2 mb-0">
                                                Manage your digital assets and NFTs
                                          </p>
                                    </CCol>
                                    <CCol md={6} className="text-end">
                                          {isVerifiedCreator ? (
                                                <CButton
                                                      color="primary"
                                                      onClick={() => setShowNewArtworkModal(true)}
                                                      className="px-4"
                                                >
                                                      <i className="fas fa-plus-circle me-2"></i>
                                                      Add New Artwork
                                                </CButton>
                                          ) : (
                                                <CButton
                                                      color="secondary"
                                                      onClick={handleCreatorNavigation}
                                                      className="px-4"
                                                >
                                                      <i className="fas fa-star me-2"></i>
                                                      Become a Verified Creator
                                                </CButton>
                                          )}
                                    </CCol>
                              </CRow>
                        </CCardBody>
                  </CCard>
            </div>
      );

      useEffect(() => {
            const countListedItems = yourArtwork.filter(art => art.status === 'LISTED').length;
            setListedItemsCount(countListedItems);
      }, [yourArtwork]);

      const renderStats = () => (
            <CRow className="mb-4">
                  <CCol sm={4}>
                        <CCard className="border-0 shadow-sm h-100">
                              <CCardBody className="text-center">
                                    <h3 className="mb-2">{yourArtwork.length}</h3>
                                    <p className="mb-2 mb-0">Total Items</p>
                              </CCardBody>
                        </CCard>
                  </CCol>
                  <CCol sm={4}>
                        <CCard className="border-0 shadow-sm h-100">
                              <CCardBody className="text-center">
                                    <h3 className="mb-2">{listedItemsCount}</h3>
                                    <p className="mb-2 mb-0">Listed Items</p>
                              </CCardBody>
                        </CCard>
                  </CCol>
                  <CCol sm={4}>
                        <CCard className="border-0 shadow-sm h-100">
                              <CCardBody className="text-center">
                                    <h3 className="mb-2">{notifications.length}</h3>
                                    <p className="mb-2 mb-0">Notifications</p>
                              </CCardBody>
                        </CCard>
                  </CCol>
            </CRow>
      );

      const creatorEmail =
            authUser?.authUser?.email ||
            authUser?.email ||
            firebase?.auth?.currentUser?.email ||
            null;

      useEffect(() => {
            const checkCreatorStatus = async () => {
                  if (!creatorEmail) {
                        setIsVerifiedCreator(false);
                        return;
                  }

                  try {
                        const firebaseDb = db || getDatabase();
                        const creatorsRef = ref(firebaseDb, 'verified_creators');
                        const normalizedEmail = String(creatorEmail).trim().toLowerCase();

                        // Primary path: indexed query by exact email.
                        const emailQuery = query(creatorsRef, orderByChild('email'), equalTo(creatorEmail));
                        let snapshot = await get(emailQuery);
                        let creatorRows = snapshot.exists() ? Object.values(snapshot.val()) : [];

                        // Fallback: case-insensitive scan if exact match misses.
                        if (!creatorRows.length) {
                              const allSnapshot = await get(creatorsRef);
                              if (allSnapshot.exists()) {
                                    creatorRows = Object.values(allSnapshot.val()).filter((row) =>
                                          String(row?.email || '').trim().toLowerCase() === normalizedEmail
                                    );
                              }
                        }

                        if (creatorRows.length) {
                              const creatorData = creatorRows.sort((a, b) => {
                                    const aTs = a?.updatedAt || a?.timestamp || a?.createdAt || 0;
                                    const bTs = b?.updatedAt || b?.timestamp || b?.createdAt || 0;
                                    return bTs - aTs;
                              })[0] || {};

                              const onboardingStatus = String(creatorData.onboardingStatus || '').toLowerCase();
                              const paymentStatus = String(
                                    creatorData.payment_status || creatorData.paymentStatus || creatorData.status || ''
                              ).toLowerCase();
                              const verifiedFlag = creatorData.verified === true;

                              const isCreatorVerified =
                                    onboardingStatus === 'complete' ||
                                    onboardingStatus === 'completed' ||
                                    paymentStatus === 'paid' ||
                                    verifiedFlag;

                              Logger.debug('Creator verification evaluation:', {
                                    creatorEmail: normalizedEmail,
                                    onboardingStatus,
                                    paymentStatus,
                                    verifiedFlag,
                                    isCreatorVerified
                              });
                              setIsVerifiedCreator(isCreatorVerified);
                        } else {
                              Logger.debug('No creator record found for email:', normalizedEmail);
                              setIsVerifiedCreator(false);
                        }
                  } catch (error) {
                        console.error('Error checking creator status:', error);
                        setIsVerifiedCreator(false);
                  }
            };

            checkCreatorStatus();
      }, [creatorEmail, db, firebase]);

      return (
            <CContainer fluid className="p-4">
                  {renderHeader()}
                  {renderStats()}

                  <CCard className="border-0 shadow-sm mb-4">
                        <CCardHeader className="bg-transparent border-bottom-0">
                              <h3 className="mb-0">My Artwork</h3>
                        </CCardHeader>
                        <CCardBody>
                              {renderYourArtwork()}
                        </CCardBody>
                  </CCard>

                  {/* Add Routes for modal */}
                  <Routes>
                        <Route 
                              path="/listing/:listingId" 
                              element={
                                    <ArtworkDetailModal
                                          show={showDetailModal}
                                          onHide={handleModalClose}
                                          artwork={selectedDetailArtwork}
                                          isMarketplace={false}
                                          authUser={authUser}
                                    />
                              } 
                        />
                  </Routes>

                  {/* Fallback modal for non-route based display */}
                  {!location.pathname.includes('/listing/') && (
                        <ArtworkDetailModal
                              show={showDetailModal}
                              onHide={handleModalClose}
                              artwork={selectedDetailArtwork}
                              isMarketplace={false}
                              authUser={authUser}
                        />
                  )}

                  {/* Other modals */}
                  <NewArtwork
                        show={showNewArtworkModal}
                        onHide={() => setShowNewArtworkModal(false)}
                        authUser={authUser}
                        addArtwork={addArtworkToState}
                        onSuccess={() => {
                              setShowNewArtworkModal(false);
                              getYourArtwork();
                        }}
                  />

                  <ListNFTModal
                        show={showListNFTModal}
                        onHide={() => {
                              setShowListNFTModal(false);
                              setSelectedNFTForListing(null);
                        }}
                        nft={selectedNFTForListing}
                        onSuccess={handleListingSuccess}
                  />
            </CContainer>
      );
};

const condition = authUser => !!authUser;

export default withEmailVerification(withAuthorization(condition)(MyStuff));


